export default "__VITE_ASSET__D$DQOagd__"